import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [],
  template: `
   <div class="bottom-sheet">
     <div class="text"> Voulez-vous actualiser cette page ? </div>
     <span class="bottom-sheet-button text" (click)="clearBar()">Annuler</span>
     <span class="bottom-sheet-button action" (click)="changeStatus()">Oui</span>
   </div>
  `,
  styles: `
    .bottom-sheet 
    {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        padding: 10px 20px;
    }
    ::ng-deep .cdk-dialog-container 
    {
      background-color: #2f3033;
      border-radius: 4px;
      margin-bottom:0.3rem;
      padding: 0;
    }
    .text
    {
      color: #f2f0f4
    }
    .action
    {
      color: #ff4081
    }
    .bottom-sheet-button
    {
      cursor: pointer;
    }
  `
})

export class SnackBarComponent
{
  constructor(
    private bottomSheetRef: MatBottomSheetRef<any>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

  clearBar()
  {
    this.bottomSheetRef.dismiss({
      message: 'cancel',
      data: this.data
    })
  }

  changeStatus()
  {
    this.bottomSheetRef.dismiss({
      message: 'reload',
      data: this.data
    })
  }
}
